﻿import * as React from 'react';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import HeadBar from './head-bar/HeadBar';
import NavBar from './nav-bar/NavBar';

type PhotoNavbarProps = {
    systemVersion: string;
    site: string;
};

/**
 * This is used to push the content from underneath the app bars.
 * See: https://mui.com/components/app-bar/#fixed-placement
 */
let Offset = styled('div')(({ theme }) => ({
    width: theme.mixins.toolbar.width,
    maxHeight: '48px',
    minHeight: '48px'
}));

function PhotoNavbar({ systemVersion, site }: PhotoNavbarProps) {
    return (
        <Box>
            <HeadBar systemVersion={systemVersion} site={site} />
            <Offset />
            <NavBar />
            <Offset />
        </Box>
    );
}

export default PhotoNavbar;
